export default __webpack_public_path__ + "static/media/knock.dfcc40bd.svg";